function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 7.5C0 3.36 3.3525 0 7.4925 0C11.64 0 15 3.36 15 7.5C15 11.64 11.64 15 7.4925 15C3.3525 15 0 11.64 0 7.5ZM4.875 4.5C4.25368 4.5 3.75 5.00368 3.75 5.625C3.75 6.24632 4.25368 6.75 4.875 6.75C5.49632 6.75 6 6.24632 6 5.625C6 5.00368 5.49632 4.5 4.875 4.5ZM10.125 4.5C9.50368 4.5 9 5.00368 9 5.625C9 6.24632 9.50368 6.75 10.125 6.75C10.7463 6.75 11.25 6.24632 11.25 5.625C11.25 5.00368 10.7463 4.5 10.125 4.5ZM7.5 14C3.90875 14 1 11.0913 1 7.5C1 3.90875 3.90875 1 7.5 1C11.0913 1 14 3.90875 14 7.5C14 11.0913 11.0913 14 7.5 14ZM10.0349 9.09746C10.1924 8.83496 10.5449 8.75246 10.8074 8.91746C11.0699 9.08246 11.1524 9.42746 10.9874 9.68996C10.2224 10.8975 8.92493 11.625 7.49993 11.625C6.07493 11.625 4.77743 10.905 4.01243 9.68246C3.84743 9.41996 3.92993 9.07496 4.19243 8.90996C4.45493 8.74496 4.79993 8.82746 4.96493 9.08996C5.51993 9.97496 6.46493 10.5 7.49993 10.5C8.53493 10.5 9.47993 9.97496 10.0349 9.09746Z",
  fill: "inherit",
  stroke: "none"
});

var SvgSmile = function SvgSmile(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmile, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/smile.5771a3bd.svg";
export { ForwardRef as ReactComponent };